export const selectMasterActionResolutions = (state) => state.actionResolutions.actionResolutions;

export const selectActionResolutions = (state) => state.actionResolutions.list;
export const selectActionResolutionsLoading = (state) => state.actionResolutions.loading;
export const selectActionResolutionsPag = (state) => state.actionResolutions.listPag;
export const selectActionResolutionsLoadingPag = (state) => state.actionResolutions.loadingPag;
export const selectActionResolutionsError = (state) => state.actionResolutions.error;